module.exports = __webpack_public_path__ + "static/img/system.f3502f0c.png";